import { useEffect, useState } from "react";
import { GeoJSON } from "react-leaflet";
import { REGION_ISO } from "../../lib/adventureConstants";

const BOUNDARY_URL = (iso) =>
  `https://raw.githubusercontent.com/johan/world.geo.json/master/countries/${iso}.geo.json`;

const STYLE = { color: "#D95A40", weight: 2.5, fillColor: "#D95A40", fillOpacity: 0.05, dashArray: "" };

export default function CountryBoundary({ regionId }) {
  const [features, setFeatures] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const isos = REGION_ISO[regionId] || [];
    if (!isos.length) { setFeatures(null); return; }
    Promise.all(
      isos.map((iso) =>
        fetch(BOUNDARY_URL(iso)).then((r) => (r.ok ? r.json() : null)).catch(() => null)
      )
    ).then((results) => {
      if (cancelled) return;
      const feats = [];
      results.forEach((fc) => {
        if (fc && fc.features) feats.push(...fc.features);
      });
      setFeatures(feats.length ? { type: "FeatureCollection", features: feats } : null);
    });
    return () => { cancelled = true; };
  }, [regionId]);

  if (!features) return null;
  return <GeoJSON key={regionId} data={features} style={STYLE} interactive={false} />;
}
